import Immutable from 'immutable';
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  data: Immutable.List(),
  isFetching: false,
};

export default function orders(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ORDERS_REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
        data: Immutable.List(),
      });
    case ActionTypes.ORDERS_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: Immutable.List(action.data),
      });
    default:
      return state;
  }
}
